export default __webpack_public_path__ + "static/media/Streamlabs_logo.786909b3.svg";